import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import { History, LocationState } from 'history';

import { authReducer } from '../auth/redux/authReducer';
import { categoryReducer } from '../../features/category/redux/categoryReducer';
import { commonReducer } from '../../shared/redux/commonReducer';
import { articleReducer } from '../../features/article/redux/articleReducer';
import { keywordReducer } from '../../features/keyword/redux/keywordReducer';
import { multimediaReducer } from '../../features/multimedia/redux/multimediaReducer';
import { usersReducer } from '../../features/users/redux/usersReducer';

const rootReducer = (history: History<LocationState>) =>
  combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    common: commonReducer,
    category: categoryReducer,
    article: articleReducer,
    keyword: keywordReducer,
    multimedia: multimediaReducer,
    users: usersReducer,
  });

export default rootReducer;
